$(document).ready(function() {
  $('.select-service-units').click(function() {
    var $this = $(this)
    $.each($('.select-service-units'), function(idx, element) {
      $(element).removeClass('border-primary border-1')
    })

    $this.addClass('border-primary border-1')
    $('#service-unit-id').val($this.attr('data-address-id'))
  })
})
